import React from "react";
import { Link } from "react-router-dom";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import palpiteImage from "../../images/selecao-bravecto-palpite.webp";

import "./Palpite.scss";

const Palpite = () => {
  document.title = "Clube Bravecto | Palpite";

  return (
    <div id="Palpite">
      <Header hideLoginButton />

      <div className="banner">
        <Link to="/login">
          <img src={palpiteImage} alt="Seleção Bravecto Palpite" />
        </Link>
      </div>

      <Footer />
    </div>
  );
};

export default Palpite;
